import {CountryBM} from "@/core/models/metadata/CountryBM";
import {MetadataService} from "@/core/services/metadata-service";
import {CountryId_Russia} from "@/core/constants/technical-defaults";
import {BaseUrlProvider} from "@/core/providers/base-url-provider";
import {AxiosInstanceProvider} from "@/core/providers/axios-instance-provider";
import {GeoLocationClient} from "@/generated/clients";

export class IPGeocodingService {

    // Сгенерированный из swagger клиент нашего эндпоинта GET /geo-location.
    private readonly geoLocationClient = new GeoLocationClient(
        BaseUrlProvider.getBaseUrl(), AxiosInstanceProvider.Get());

    private readonly metadataService = new MetadataService();

    // Определяет страну посетителя через НАШЕ API. Бэкенд сам резолвит страну по IP и сам
    // применяет дефолт (Россию), если определить не удалось, — поэтому в ответе ВСЕГДА есть
    // валидный CountryId. Фронт лишь берёт по нему страну из справочника метаданных (страну
    // по умолчанию здесь НЕ решаем — эта логика на бэке). Внешние платные гео-сервисы не используются.
    public async getCurrentUserCountry(): Promise<CountryBM> {
        const countries = await this.metadataService.ReadCountries();

        try {
            const result = await this.geoLocationClient.resolveLocation();
            return countries.find(c => c.Id === result.CountryId)!;
        } catch (exception) {
            // Подстраховка ТОЛЬКО на случай недоступности API (не гео-дефолт — он на бэке).
            console.log(exception);
            return countries.find(c => c.Id === CountryId_Russia)!;
        }
    }
}
